import keyMirror from 'keymirror'

const ActionTypes = keyMirror({
  HOTEL_RETAIL_SEARCH: null,
  HOTEL_SOPQ_SEARCH: null,
  HOTEL_PATH_CUG_ELIGIBLE: null,

  FLIGHT_RETAIL_SEARCH: null,
  FLIGHT_SOPQ_SEARCH: null,
  FLIGHT_ADD_MULTI: null,
  FLIGHT_REMOVE_MULTI: null,
  FLIGHT_UPDATE: null,
  FLIGHT_NEARBY_AIRPORT: null,

  RENTAL_CAR_RETAIL_SEARCH: null,
  RENTAL_CAR_SOPQ_SEARCH: null,

  VACACTION_PACKAGE_SEARCH: null,

  CRUISE_SEARCH: null,

  LOCATION_SEARCH_FOUND: null,
  LOCATION_SEARCH_BLOCKED: null,

  RENTAL_CAR_TYPE_SEARCH: null,

  EMAIL_SIGN_UP_SUBMIT: null,
  TOGGLE_SEARCH_FORM: null,
  TOGGLE_DEALS_MODAL: null,

  RECENT_SEARCH_UPDATE: null,

  SELECT_RECENT_SEARCH: null,
  SELECT_UPCOMING_TRIP: null,

  UPCOMING_TRIPS_UPDATE: null,
  RENTAL_CAR_LISTING: null,
  HOTEL_LISTING: null,

  PRICING_DESTINATIONS_UPDATE: null
})

export default ActionTypes
